import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('tool.index', params);
    },
    create: (context, params) => {
        return apiService.post('tool.index', params);
    },
    update: (context, params) => {
        return apiService.put('tool.detail', params);
    },
    delete: (context, params) => {
        return apiService.delete('tool.detail', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
